import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import i18n from 'i18next';
import { Order } from '../Types';
import { ordersApiSlice } from './OrdersApi';

const SLICE_NAME = 'orders';

const ordersSlice = createSlice({
  name: SLICE_NAME,
  initialState: {},
  reducers: {},
  extraReducers(builder) {
    builder.addMatcher(
      ordersApiSlice.endpoints.cancelOrder.matchFulfilled,
      (_state, { payload: order }: PayloadAction<Order>) => {
        // TODO: notification
        // notify.success(i18n.t('orders:notifications.item-cancelled-notification', { id: order.id }));
      },
    );
    builder.addMatcher(
      ordersApiSlice.endpoints.updateOrder.matchFulfilled,
      (_state, { payload: order }: PayloadAction<Order>) => {        
        // TODO: notification
        // notify.success(i18n.t('checkout:notifications.order-submitted', { id: order.id }));
      },
    );
  },
});

export default ordersSlice.reducer;
